import classNames from 'classnames';
import React from 'react';
import {
  GridCell,
  GridRow,
} from '../../../../../../common/components/Grid/Grid';

type Props = {
  className?: string;
  children?: JSX.Element[];
  onClick: () => void;
  inactive?: boolean;
};

const fractions = [2.5, 2, 1.5, 1, 1, 1, 1, 0];

export const EntityRowBaseTemplate = ({
  className,
  children,
  onClick,
  inactive,
}: Props) => {
  const cells = [...(children || [])].splice(0, fractions.length);
  const rest = [...(children || [])].splice(fractions.length, children?.length);
  return (
    <GridRow
      className={classNames(className, 'entity-row-base-template', {
        'entity-row-base-template--inactive': inactive,
      })}
      onClick={onClick}
    >
      {fractions.map((fr, i) => (
        <GridCell key={i} fr={fr}>
          {cells[i]}
        </GridCell>
      ))}
      {rest}
    </GridRow>
  );
};
